// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-07-18T10:35:20Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 * Obecný controller pro neshlukované api akce @author Petr Compel <petr.compel@marbes.cz> @since 13.3.2016 Generated from cz.marbes.cgo.controller.CgoController.
 */
export default class CgoApi {
    /**
     * Reset hesla @param request kód pro reset a nové heslo
     *
     * @param request 
     */
    static resetPassword(request) {
        const uri = serverContextPath + `/api/password-reset`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, request, headers));
    }

    /**
     * Vrátí sitekey pro reCAPTCHA v případě, že je reCAPTCHA pro daného klienta vyžadována. @return sitekey nebo {@code null} pokud není reCAPTCHA vyžadována
     *
     * @return java.lang.String
     */
    static getReCaptchaSiteKey() {
        const uri = serverContextPath + `/api/recaptcha/site-key`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Request pro reset hesla @param request login name a captcha
     *
     * @param request 
     */
    static requestPasswordReset(request) {
        const uri = serverContextPath + `/api/password-reset-request`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, request, headers));
    }

}
